import { render } from "./Header.vue?vue&type=template&id=c8fc293e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c8fc293e&lang=scss&scoped=true"

import exportComponent from "/tmp/build_cd2b88ef/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8fc293e"]])

export default __exports__